import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { ErrorDTO } from "interface";
import { BRAND_END_POINTS } from "core/constants/endpoints";
import instance from "core/constants/request";
import { brandForm } from "../type";

const updateBrand = async ({ data }: { data: brandForm }) => {
  const formData = new FormData();
  formData.append("Id", String(data.id));
  formData.append("AltText", "");
  formData.append("Name", data.name);
  formData.append("LocalLink", data.localLink);
  formData.append("Identifier", data.identifier);
  formData.append("IsActive", String(data.isActive));
  formData.append("Description", data?.description ?? "");

  if (data.image) {
    formData.append("Width", String(data.image.width));
    formData.append("Height", String(data.image.height));
    formData.append("SizePercentage", "100");
    formData.append("File", data.image.file ?? "");
    // TODO(hossein): separate thumbnail from image
    formData.append("Thumbnail.Width", String(data.image.width));
    formData.append("Thumbnail.Height", String(data.image.height));
    formData.append("Thumbnail.SizePercentage", "100");
    formData.append("Thumbnail.File", data.image.file ?? "");
  }

  const res = await instance.put(BRAND_END_POINTS.update_brand, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res.data;
};

export const useUpdateBrand = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [BRAND_END_POINTS.update_brand, BRAND_END_POINTS.brands_list],
    mutationFn: updateBrand,
    onError: (e: AxiosError<ErrorDTO>) => {
      toast.error(`${e.response?.data.Message || "خطا در ویرایش برند"}`);
    },
    onSuccess: () => {
      toast.success(`برند با موفقیت ویرایش شد`);
      queryClient.invalidateQueries({
        queryKey: [BRAND_END_POINTS.brands_list],
      });
    },
  });
};
